import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a1ede3ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "circular-border" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ou-container" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "ou" }, [
    /*#__PURE__*/_createElementVNode("span", null, "ou")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_simple_header = _resolveComponent("simple-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_simple_header, {
            title: "Junte-se a nós",
            "header-img": "assets/registerHeader.webp",
            "has-go-back-modal": $props.isModal,
            "has-go-back": !$props.isModal
          }, null, 8, ["has-go-back-modal", "has-go-back"]),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_ion_grid, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { position: "floating" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Nome")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_input, {
                              modelValue: _ctx.name,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
                              class: "capitalize",
                              type: "text",
                              autocomplete: "name"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { position: "floating" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Celular")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_input, {
                              modelValue: _ctx.phone,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.phone) = $event)),
                              type: "tel",
                              autocomplete: "tel-national"
                            }, null, 8, ["modelValue"]),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.phone) = $event)),
                              style: {"display":"none"}
                            }, null, 512), [
                              [_vModelText, _ctx.phone],
                              [_directive_mask, '(##) #####-####']
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { position: "floating" }, {
                              default: _withCtx(() => [
                                _createTextVNode("E-mail")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_input, {
                              modelValue: _ctx.email,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.email) = $event)),
                              type: "email",
                              autocomplete: "email"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { position: "floating" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Data de Nascimento")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_input, {
                              modelValue: _ctx.birth,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.birth) = $event)),
                              type: "tel",
                              autocomplete: "bday"
                            }, null, 8, ["modelValue"]),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.birth) = $event)),
                              style: {"display":"none"}
                            }, null, 512), [
                              [_vModelText, _ctx.birth],
                              [_directive_mask, '##/##/####']
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { position: "floating" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Gênero")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_select, {
                              modelValue: _ctx.gender,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.gender) = $event)),
                              "ok-text": "OK",
                              "cancel-text": "Cancelar"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_select_option, { value: "M" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Masculino")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_select_option, { value: "F" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Feminino")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_select_option, { value: "O" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Outro")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_select_option, { value: "N" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Prefiro não informar")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { position: "floating" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Cupom de indicação")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_input, {
                              modelValue: $setup.ref,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.ref) = $event)),
                              disabled: $setup.disableRef
                            }, null, 8, ["modelValue", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, { class: "terms" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Ao se registrar, você concorda com os "),
                        _createElementVNode("a", {
                          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($options.openTermsAndConditionsModal && $options.openTermsAndConditionsModal(...args)))
                        }, "termos e condições"),
                        _createTextVNode(" do serviço. ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          shape: "round",
                          color: "primary",
                          expand: "full",
                          onClick: $options.goRegister
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Cadastrar ")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, null, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          shape: "round",
                          color: "primary",
                          expand: "full",
                          fill: "outline",
                          onClick: $setup.goBack
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Entrar ")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}